import { render, staticRenderFns } from "./portrait-card.vue?vue&type=template&id=68f540b8&scoped=true&"
import script from "./portrait-card.vue?vue&type=script&lang=ts&"
export * from "./portrait-card.vue?vue&type=script&lang=ts&"
import style0 from "./portrait-card.vue?vue&type=style&index=0&id=68f540b8&prod&lang=scss&"
import style1 from "./portrait-card.vue?vue&type=style&index=1&id=68f540b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f540b8",
  null
  
)

export default component.exports